import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap"
import {Decadence} from "../Decadence";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

export class DecadenceIdleFlow implements FlowStatePresentation {
    private tl:gsap.core.Timeline;

    private skip(data:APIFeatureBetEventData):void {
        this.tl.kill();
    }

    private onComplete(flowStateController:FlowStateController) {
        flowStateController.finish();
    }

    constructor() {
        this.tl = gsap.timeline();
        Decadence.apiPlugin.events.on(APIEvent.BET, (data:APIFeatureBetEventData) => {this.skip(data)});
    }

    public start(flowStateController: FlowStateController) {
        flowStateController.setSkipCallback(() => { this.onComplete(flowStateController) });

        this.tl = gsap.timeline();
        if(!Decadence.apiPlugin.freeBets.hasFreeBets()) {
            this.tl.add(() => {
                Decadence.reelSelectView.unlockButtons()
            }, 0.25);
        }
    }
}